import React, { Component } from 'react'
import { Icon } from 'antd'
import TierIcon from './TierIcon'
import EmbroideryItemsTable, { BatchLink } from './EmbroideryItemsTable'
import { STAGES, STAGE_LABELS, formatNumber } from './embroideryFormat'

// Chế độ "Nhóm theo lô": mỗi lô một dòng, thu gọn mặc định, bấm để xem item (GAP-03)
class EmbroideryBatchGroups extends Component {
    state = { expanded: {} }

    _toggle = (key) => {
        this.setState(({ expanded }) => ({ expanded: Object.assign({}, expanded, { [key]: !expanded[key] }) }))
    }

    render() {
        const { groups, overdueActive } = this.props
        const { expanded } = this.state

        if (!groups.length) {
            return <div className='text-center empty p-3'>Không có item nào khớp bộ lọc. Bỏ bớt điều kiện lọc để xem thêm.</div>
        }

        return (
            <div className='EmbroideryBatchGroups'>
                {groups.map((group) => {
                    const key = group.batch_id ? String(group.batch_id) : 'none'
                    const open = !!expanded[key]
                    const distribution = STAGES
                        .filter((stage) => group.stage_distribution[stage] > 0)
                        .map((stage) => `${STAGE_LABELS[stage]}: ${formatNumber(group.stage_distribution[stage])}`)
                        .join(' · ')

                    return (
                        <div key={key} className='group'>
                            <div className='groupHead' onClick={() => this._toggle(key)}>
                                <Icon type={open ? 'down' : 'right'} className='mr-2' />
                                <strong onClick={(e) => e.stopPropagation()}>
                                    <BatchLink batchId={group.batch_id}>{group.batch_name || 'Chưa phân lô'}</BatchLink>
                                </strong>
                                {group.partner_name && <span className='ml-2 text-muted'>{group.partner_name}</span>}
                                <span className='ml-3'>{formatNumber(group.item_count)} item</span>
                                {group.overdue_count > 0 && (
                                    <span className='ml-3 tier-overdue'><TierIcon type='overdue' size={12} />{formatNumber(group.overdue_count)} quá hạn</span>
                                )}
                                {group.near_overdue_count > 0 && (
                                    <span className='ml-3 tier-near_overdue'><TierIcon type='near_overdue' size={12} />{formatNumber(group.near_overdue_count)} sắp</span>
                                )}
                                <span className='ml-3 text-muted'>{distribution}</span>
                            </div>
                            {open && <EmbroideryItemsTable items={group.items} />}
                            {open && group.items_truncated && (
                                <div className='text-muted p-2'>
                                    Chỉ hiển thị {formatNumber(group.items.length)}/{formatNumber(group.item_count)} item của lô này.
                                    Chuyển sang chế độ "Theo item" để xem đủ{overdueActive ? '.' : ', hoặc tìm theo tên lô ở ô tìm kiếm.'}
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        )
    }
}

export default EmbroideryBatchGroups
